import { render, staticRenderFns } from "./DrugSearchDialog.vue?vue&type=template&id=b8370a40&"
import script from "./DrugSearchDialog.vue?vue&type=script&lang=js&"
export * from "./DrugSearchDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports